export default __webpack_public_path__ + "static/media/sendmoney.738bfdd9.gif";